// extracted by mini-css-extract-plugin
export var logo = "sovcomHalva-module--logo--CEOWv";